// // import {
// //   Box,
// //   Input,
// //   List,
// //   ListItem,
// //   Spinner,
// //   Text
// // } from "@chakra-ui/react";

// // import { useEffect, useMemo, useRef, useState } from "react";

// // import { FichaService } from "../../services/ficha.service";

// // interface PacienteItem {
// //   id: number;
// //   nome: string;
// //   cpf?: string | null;
// // }

// // interface Props {
// //   valueId?: number | null;
// //   valueLabel?: string;
// //   onSelect: (item: PacienteItem | null) => void;
// //   placeholder?: string;
// // }

// // export default function PacienteAutocomplete({
// //   valueId,
// //   valueLabel,
// //   onSelect,
// //   placeholder = "Digite nome ou CPF do paciente"
// // }: Props) {

// //   const [term, setTerm] = useState(valueLabel || "");
// //   const [loading, setLoading] = useState(false);
// //   const [open, setOpen] = useState(false);
// //   const [options, setOptions] = useState<PacienteItem[]>([]);
// //   const rootRef = useRef<HTMLDivElement | null>(null);

// //   useEffect(() => {
// //     setTerm(valueLabel || "");
// //   }, [valueLabel, valueId]);

// //   useEffect(() => {
// //     function onClickOutside(event: MouseEvent) {
// //       if (!rootRef.current) return;
// //       if (!rootRef.current.contains(event.target as Node)) {
// //         setOpen(false);
// //       }
// //     }

// //     document.addEventListener("mousedown", onClickOutside);

// //     return () => {
// //       document.removeEventListener("mousedown", onClickOutside);
// //     };
// //   }, []);

// //   useEffect(() => {
// //     const timer = setTimeout(async () => {
// //       try {
// //         setLoading(true);
// //         const data = await FichaService.findLookup(term);
// //         setOptions(Array.isArray(data) ? data : []);
// //       } finally {
// //         setLoading(false);
// //       }
// //     }, 250);

// //     return () => clearTimeout(timer);
// //   }, [term]);

// //   const emptyMessage = useMemo(() => {
// //     if (loading) return "";
// //     if (!term.trim()) return "Digite para buscar paciente";
// //     if (!options.length) return "Nenhum paciente encontrado";
// //     return "";
// //   }, [loading, term, options.length]);

// //   function handleSelect(item: PacienteItem) {
// //     setTerm(`${item.nome || ""}${item.cpf ? ` - ${item.cpf}` : ""}`.trim());
// //     setOpen(false);
// //     onSelect(item);
// //   }

// //   return (
// //     <Box ref={rootRef} position="relative">
// //       <Input
// //         value={term}
// //         placeholder={placeholder}
// //         onFocus={() => setOpen(true)}
// //         onChange={(e) => {
// //           setTerm(e.target.value);
// //           setOpen(true);
// //           onSelect(null);
// //         }}
// //       />

// //       {open ? (
// //         <Box
// //           position="absolute"
// //           top="calc(100% + 4px)"
// //           left={0}
// //           right={0}
// //           bg="white"
// //           border="1px solid"
// //           borderColor="gray.200"
// //           borderRadius="md"
// //           boxShadow="md"
// //           zIndex={20}
// //           maxH="280px"
// //           overflowY="auto"
// //         >
// //           {loading ? (
// //             <Box p={3} display="flex" alignItems="center" gap={2}>
// //               <Spinner size="sm" />
// //               <Text fontSize="sm">Buscando pacientes...</Text>
// //             </Box>
// //           ) : null}

// //           {!loading && options.length > 0 ? (
// //             <List>
// //               {options.map((item) => (
// //                 <ListItem
// //                   key={item.id}
// //                   px={3}
// //                   py={2}
// //                   cursor="pointer"
// //                   _hover={{ bg: "gray.50" }}
// //                   onClick={() => handleSelect(item)}
// //                 >
// //                   <Text fontSize="sm" fontWeight="600">{item.nome || "Sem nome"}</Text>
// //                   <Text fontSize="xs" color="gray.600">CPF: {item.cpf || "Não informado"}</Text>
// //                 </ListItem>
// //               ))}
// //             </List>
// //           ) : null}

// //           {!loading && emptyMessage ? (
// //             <Box px={3} py={2}>
// //               <Text fontSize="sm" color="gray.600">{emptyMessage}</Text>
// //             </Box>
// //           ) : null}
// //         </Box>
// //       ) : null}
// //     </Box>
// //   );
// // }



// import {
//   Box,
//   Input,
//   List,
//   ListItem,
//   Spinner,
//   Text,
//   HStack,
//   VStack,
//   Badge
// } from "@chakra-ui/react";

// import { useEffect, useMemo, useRef, useState } from "react";
// import { FichaService } from "../../services/ficha.service";

// interface PacienteItem {
//   id: number;
//   nome: string;
//   cpf?: string | null;
//   cartao_sus?: string | null;
//   contato?: string | null;
//   bairro?: string | null;
//   cidade?: string | null;
//   uf?: string | null;
//   endereco?: string | null;
//   numero?: string | null;
// }

// interface Props {
//   valueId?: number | null;
//   valueLabel?: string;
//   onSelect: (item: PacienteItem | null) => void;
//   placeholder?: string;
// }

// function normalizeText(value: unknown) {
//   return String(value ?? "")
//     .normalize("NFD")
//     .replace(/[\u0300-\u036f]/g, "")
//     .toLowerCase()
//     .trim();
// }

// function formatAddress(item: PacienteItem) {
//   const street = [item.endereco, item.numero]
//     .filter(Boolean)
//     .join(", ");

//   const city = [item.bairro, item.cidade, item.uf]
//     .filter(Boolean)
//     .join(" - ");

//   return [street, city].filter(Boolean).join(" | ");
// }

// function formatPatientLabel(item: PacienteItem) {
//   return [
//     item.nome,
//     item.cpf ? `CPF: ${item.cpf}` : "",
//     item.cartao_sus ? `Cartão SUS: ${item.cartao_sus}` : "",
//     formatAddress(item)
//   ]
//     .filter(Boolean)
//     .join(" — ");
// }

// export default function PacienteAutocomplete({
//   valueId,
//   valueLabel,
//   onSelect,
//   placeholder = "Digite nome ou CPF do paciente"
// }: Props) {
//   const [term, setTerm] = useState(valueLabel || "");
//   const [loading, setLoading] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [options, setOptions] = useState<PacienteItem[]>([]);
//   const rootRef = useRef<HTMLDivElement | null>(null);
//   const requestRef = useRef(0);

//   useEffect(() => {
//     setTerm(valueLabel || "");
//   }, [valueLabel, valueId]);

//   useEffect(() => {
//     function onClickOutside(event: MouseEvent) {
//       if (
//         rootRef.current &&
//         !rootRef.current.contains(event.target as Node)
//       ) {
//         setOpen(false);
//       }
//     }

//     document.addEventListener("mousedown", onClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", onClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     const searchTerm = term.trim();
//     const requestId = ++requestRef.current;

//     if (!searchTerm) {
//       setOptions([]);
//       setLoading(false);
//       return;
//     }

//     const timer = window.setTimeout(async () => {
//       try {
//         setLoading(true);

//         const data = await FichaService.findLookup(searchTerm);

//         // Ignora respostas antigas caso o usuário já tenha digitado novamente.
//         if (requestId !== requestRef.current) return;

//         const results = Array.isArray(data)
//           ? data
//           : Array.isArray((data as any)?.data)
//             ? (data as any).data
//             : [];

//         const normalizedTerm = normalizeText(searchTerm);

//         // Filtro local complementar. A busca principal continua sendo feita
//         // pelo backend através de FichaService.findLookup.
//         const filtered = results.filter((item: PacienteItem) => {
//           const searchableText = normalizeText([
//             item.nome,
//             item.cpf,
//             item.cartao_sus,
//             item.contato,
//             item.bairro,
//             item.cidade,
//             item.uf
//           ].filter(Boolean).join(" "));

//           return searchableText.includes(normalizedTerm);
//         });

//         setOptions(filtered);
//       } catch (error) {
//         if (requestId === requestRef.current) {
//           setOptions([]);
//         }
//       } finally {
//         if (requestId === requestRef.current) {
//           setLoading(false);
//         }
//       }
//     }, 250);

//     return () => window.clearTimeout(timer);
//   }, [term]);

//   const emptyMessage = useMemo(() => {
//     if (loading) return "";
//     if (!term.trim()) return "Digite o nome ou CPF do paciente";
//     if (!options.length) return "Nenhum paciente encontrado";
//     return "";
//   }, [loading, term, options.length]);

//   function handleSelect(item: PacienteItem) {
//     setTerm(formatPatientLabel(item));
//     setOpen(false);
//     onSelect(item);
//   }

//   return (
//     <Box ref={rootRef} position="relative" width="100%">
//       <Input
//         value={term}
//         placeholder={placeholder}
//         autoComplete="off"
//         onFocus={() => setOpen(true)}
//         onChange={(event) => {
//           setTerm(event.target.value);
//           setOpen(true);
//           onSelect(null);
//         }}
//       />

//       {open && (
//         <Box
//           position="absolute"
//           top="calc(100% + 4px)"
//           left={0}
//           right={0}
//           bg="white"
//           border="1px solid"
//           borderColor="gray.200"
//           borderRadius="lg"
//           boxShadow="lg"
//           zIndex={1500}
//           maxH="320px"
//           overflowY="auto"
//         >
//           {loading && (
//             <HStack p={3} spacing={2}>
//               <Spinner size="sm" color="blue.500" />
//               <Text fontSize="sm" color="gray.600">
//                 Buscando pacientes...
//               </Text>
//             </HStack>
//           )}

//           {!loading && options.length > 0 && (
//             <List spacing={0}>
//               {options.map((item) => (
//                 <ListItem
//                   key={item.id}
//                   px={3}
//                   py={3}
//                   cursor="pointer"
//                   borderBottom="1px solid"
//                   borderColor="gray.100"
//                   transition="background 0.15s"
//                   _hover={{ bg: "blue.50" }}
//                   onMouseDown={(event) => event.preventDefault()}
//                   onClick={() => handleSelect(item)}
//                 >
//                   <VStack align="stretch" spacing={1}>
//                     <HStack justify="space-between" align="start">
//                       <Text
//                         fontSize="sm"
//                         fontWeight="700"
//                         color="gray.800"
//                       >
//                         {item.nome || "Paciente sem nome"}
//                       </Text>

//                       <Badge colorScheme="blue" fontSize="xs">
//                         Ficha #{item.id}
//                       </Badge>
//                     </HStack>

//                     <Text fontSize="xs" color="gray.600">
//                       CPF: {item.cpf || "Não informado"}
//                     </Text>

//                     {item.cartao_sus && (
//                       <Text fontSize="xs" color="gray.600">
//                         Cartão SUS: {item.cartao_sus}
//                       </Text>
//                     )}

//                     {(item.bairro || item.cidade || item.uf) && (
//                       <Text fontSize="xs" color="gray.600">
//                         {[item.bairro, item.cidade, item.uf]
//                           .filter(Boolean)
//                           .join(" - ")}
//                       </Text>
//                     )}

//                     {item.contato && (
//                       <Text fontSize="xs" color="gray.500">
//                         Contato: {item.contato}
//                       </Text>
//                     )}
//                   </VStack>
//                 </ListItem>
//               ))}
//             </List>
//           )}

//           {!loading && emptyMessage && (
//             <Box px={3} py={3}>
//               <Text fontSize="sm" color="gray.600">
//                 {emptyMessage}
//               </Text>
//             </Box>
//           )}
//         </Box>
//       )}
//     </Box>
//   );
// }



import {
  Box,
  Input,
  List,
  ListItem,
  Spinner,
  Text,
  HStack,
  VStack,
  Badge
} from "@chakra-ui/react";

import { useEffect, useMemo, useRef, useState } from "react";
import { FichaService } from "../../services/ficha.service";

interface PacienteItem {
  id: number;
  nome: string;
  cpf?: string | null;
  titulo?: string | number | null;
  cartao_sus?: string | null;
  contato?: string | null;
  bairro?: string | null;
  cidade?: string | null;
  uf?: string | null;
  endereco?: string | null;
  numero?: string | number | null;
}

interface Props {
  valueId?: number | null;
  valueLabel?: string;
  onSelect: (item: PacienteItem | null) => void;
  placeholder?: string;
}

function normalizeText(value: unknown) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

function formatAddress(item: PacienteItem) {
  const street = [item.endereco, item.numero]
    .filter((value) => value !== null && value !== undefined && String(value).trim() !== "")
    .join(", ");

  const location = [item.bairro, item.cidade, item.uf]
    .filter((value) => value !== null && value !== undefined && String(value).trim() !== "")
    .join(", ");

  return [street, location].filter(Boolean).join(" - ");
}

function formatPatientLabel(item: PacienteItem) {
  return [
    item.nome,
    item.cpf,
    item.titulo,
    formatAddress(item)
  ]
    .filter((value) => value !== null && value !== undefined && String(value).trim() !== "")
    .join(" - ");
}

export default function PacienteAutocomplete({
  valueId,
  valueLabel,
  onSelect,
  placeholder = "Digite nome ou CPF do paciente"
}: Props) {
  const [term, setTerm] = useState(valueLabel || "");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<PacienteItem[]>([]);

  const rootRef = useRef<HTMLDivElement | null>(null);
  const requestRef = useRef(0);

  useEffect(() => {
    setTerm(valueLabel || "");
  }, [valueLabel, valueId]);

  useEffect(() => {
    function onClickOutside(event: MouseEvent) {
      if (
        rootRef.current &&
        !rootRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", onClickOutside);

    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, []);

  useEffect(() => {
    const searchTerm = term.trim();
    const requestId = ++requestRef.current;

    if (!searchTerm) {
      setOptions([]);
      setLoading(false);
      return;
    }

    const timer = window.setTimeout(async () => {
      try {
        setLoading(true);

        const data = await FichaService.findLookup(searchTerm);

        // Ignora respostas antigas se o usuário digitou novamente.
        if (requestId !== requestRef.current) return;

        const results = Array.isArray(data)
          ? data
          : Array.isArray((data as any)?.data)
            ? (data as any).data
            : [];

        const normalizedTerm = normalizeText(searchTerm);

        const filtered = results.filter((item: PacienteItem) => {
          const searchableText = normalizeText([
            item.nome,
            item.cpf,
            item.titulo,
            item.cartao_sus,
            item.contato,
            item.endereco,
            item.numero,
            item.bairro,
            item.cidade,
            item.uf
          ].filter(Boolean).join(" "));

          return searchableText.includes(normalizedTerm);
        });

        setOptions(filtered);
      } catch {
        if (requestId === requestRef.current) {
          setOptions([]);
        }
      } finally {
        if (requestId === requestRef.current) {
          setLoading(false);
        }
      }
    }, 250);

    return () => window.clearTimeout(timer);
  }, [term]);

  const emptyMessage = useMemo(() => {
    if (loading) return "";
    if (!term.trim()) return "Digite o nome ou CPF do paciente";
    if (!options.length) return "Nenhum paciente encontrado";
    return "";
  }, [loading, term, options.length]);

  function handleSelect(item: PacienteItem) {
    setTerm(formatPatientLabel(item));
    setOpen(false);
    onSelect(item);
  }

  return (
    <Box ref={rootRef} position="relative" width="100%">
      <Input
        value={term}
        placeholder={placeholder}
        autoComplete="off"
        onFocus={() => setOpen(true)}
        onChange={(event) => {
          setTerm(event.target.value);
          setOpen(true);

          // Limpa o ID até o usuário selecionar uma ficha válida novamente.
          onSelect(null);
        }}
      />

      {open && (
        <Box
          position="absolute"
          top="calc(100% + 4px)"
          left={0}
          right={0}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="lg"
          boxShadow="lg"
          zIndex={1500}
          maxH="320px"
          overflowY="auto"
        >
          {loading && (
            <HStack p={3} spacing={2}>
              <Spinner size="sm" color="blue.500" />
              <Text fontSize="sm" color="gray.600">
                Buscando pacientes...
              </Text>
            </HStack>
          )}

          {!loading && options.length > 0 && (
            <List spacing={0}>
              {options.map((item) => (
                <ListItem
                  key={item.id}
                  px={3}
                  py={3}
                  cursor="pointer"
                  borderBottom="1px solid"
                  borderColor="gray.100"
                  transition="background 0.15s"
                  _hover={{ bg: "blue.50" }}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => handleSelect(item)}
                >
                  <VStack align="stretch" spacing={1}>
                    <HStack justify="space-between" align="start">
                      <Text
                        fontSize="sm"
                        fontWeight="700"
                        color="gray.800"
                      >
                        {item.nome || "Paciente sem nome"}
                      </Text>

                      <Badge colorScheme="blue" fontSize="xs" flexShrink={0}>
                        Ficha #{item.id}
                      </Badge>
                    </HStack>

                    <Text fontSize="xs" color="gray.600">
                      CPF: {item.cpf || "Não informado"}
                    </Text>

                    <Text fontSize="xs" color="gray.600">
                      Título: {item.titulo || "Não informado"}
                    </Text>

                    <Text fontSize="xs" color="gray.600">
                      Endereço: {formatAddress(item) || "Não informado"}
                    </Text>

                    {item.cartao_sus && (
                      <Text fontSize="xs" color="gray.600">
                        Cartão SUS: {item.cartao_sus}
                      </Text>
                    )}

                    {item.contato && (
                      <Text fontSize="xs" color="gray.500">
                        Contato: {item.contato}
                      </Text>
                    )}
                  </VStack>
                </ListItem>
              ))}
            </List>
          )}

          {!loading && emptyMessage && (
            <Box px={3} py={3}>
              <Text fontSize="sm" color="gray.600">
                {emptyMessage}
              </Text>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
